export class LinkSubprojectToProjectModel {
    constructor() {
        this.projectId = "";
        this.subProjectId = "";
        this.employeeId = "";
    }
}
export default class LinkSubprojectToProject extends LinkSubprojectToProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
